export default __webpack_public_path__ + "static/media/bw-planning-tutorial-pop-up-icon.54c571b9.svg";